
export class FileShareUpdateEntity {
  providerInstanceId: string;
  providerInstanceResourceId: string;
  name: string;
  userId: string|null;
  paths: string[];
}
